import { useContext } from "react"

import { FlagContext } from "./FlagContext"

export function useFlagProvider() {
  return useContext(FlagContext)
}
